import { Routes, Route } from "@angular/router";
import { BaseRoutingFactory } from "./base-routing.factory";
import { AusschreibungOverviewComponent } from "../features/ausschreibung/components/ausschreibung-overview/ausschreibung-overview.component";
import { FoerderprogrammResolver } from "../resolver/ausschreibung/foerderprogramm.resolver";
import { PortalkonfigurationResolver } from "../resolver/portalkonfiguration/portalkonfiguration.resolver";
import {  inject, Injectable } from "@angular/core";
import { StammdatenService } from '../services/stammdaten.service';
import { I18nService } from "../services/i18nService";

export class AusschreibungRoutingFactory extends BaseRoutingFactory {
    
    protected stammdatenService = inject(StammdatenService);
    protected languageService = inject(I18nService);

    private readonly coreAusschreibungRoute: Routes = [
        {
            path: '',
            redirectTo: 'overview',
            pathMatch: 'full'
        },
        {
            path: 'overview',
            component: this.componentService.get(AusschreibungOverviewComponent),
            resolve: {
                portalkonfiguration: this.componentService.get(PortalkonfigurationResolver),
                foerderprogramme: this.componentService.get(FoerderprogrammResolver),
            },
            title: () => this.getOverviewNavigationText + " | " + this.translateService.instant("xfound.portal.tabname")
        },
    ];

    public create(): Routes {
        const coreRoute = this.coreRoute;

        return coreRoute;
    }

    protected get coreRoute(): Routes {
        return this.coreAusschreibungRoute;
    }

    protected registerChild(coreRoute: Routes, route: Route): void {
        const formRoutes = coreRoute!;
        const foundIndex = formRoutes?.findIndex(formRoute => formRoute.path === route.path);
        if (foundIndex >= 0) {
            formRoutes[foundIndex] = route;
        }
        else {
            coreRoute!.push(route);
        }
    }

    public get getOverviewNavigationText(): string {
        let overridetext = this.languageService.getCurrentLocalizedTextDisplayModel(this.stammdatenService.Portalkonfiguration.startseiteBezeichnungTexte ?? [])
        if (overridetext && overridetext.text && overridetext.text.length > 0) {
            return overridetext.text;
        }
        return this.languageService.instant("navigation.overview");
    }
}
